
import { defineComponent, defineAsyncComponent } from 'vue';

export default defineComponent({
  name: 'Login',

  components: {
    LoginForm: defineAsyncComponent(() => import('./components/LoginForm.vue')),
  },
});
